/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Hero_DescriptionInputs */

const en_business_hero_description = /** @type {(inputs: Business_Hero_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empower your organization with AI-powered text-to-speech. Help researchers, analysts, and teams absorb more information in less time.`)
};

const es_business_hero_description = /** @type {(inputs: Business_Hero_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potencia tu organización con texto a voz impulsado por IA. Ayuda a investigadores, analistas y equipos a absorber más información en menos tiempo.`)
};

/**
* | output |
* | --- |
* | "Empower your organization with AI-powered text-to-speech. Help researchers, analysts, and teams absorb more information in less time." |
*
* @param {Business_Hero_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_hero_description = /** @type {((inputs?: Business_Hero_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Hero_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_hero_description(inputs)
	return en_business_hero_description(inputs)
});